'use client';
import { createContext, useContext } from 'react';
import { ThemeProvider } from 'next-themes';

const NonceContext = createContext<string>('');

/** Returns the per-request CSP nonce for use in inline Script nonce props. */
export function useNonce(): string {
  return useContext(NonceContext);
}

export function NonceThemeProvider({
  children,
  nonce = '',
}: {
  children: React.ReactNode;
  nonce?: string;
}) {
  return (
    <NonceContext.Provider value={nonce}>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
        {children}
      </ThemeProvider>
    </NonceContext.Provider>
  );
}
